import { render, staticRenderFns } from "./CampaignRequest.vue?vue&type=template&id=33b72fa9&scoped=true"
import script from "./CampaignRequest.vue?vue&type=script&lang=js"
export * from "./CampaignRequest.vue?vue&type=script&lang=js"
import style0 from "./CampaignRequest.vue?vue&type=style&index=0&id=33b72fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b72fa9",
  null
  
)

export default component.exports